module.exports = __webpack_public_path__ + "img/icon_heart.b649b5a4.svg";